/* SupportRequest.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { LinkButton } from '@atlaskit/button/new';
import { ANALYTICS_SUBJECT_ID_SUPPORT_TICKET_LINK, EVENT_CONTAINER_SUPPORT_APPLISTING_TAB, LinkClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import * as React from 'react';
import { SupportResourcesLink } from '../../types';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _ = "._1wyb1j6v{font-size:1rem}";
const Container = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1wyb1j6v", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
const getSupportRequestDetails = supportDetails => {
  const {
    contact: {
      issueTrackerUrl,
      supportTicketSystemUrl,
      websiteUrl
    }
  } = supportDetails;
  const commonAttributes = {
    target: '_blank',
    rel: 'external noopener noreferrer'
  };
  if (supportTicketSystemUrl) {
    const label = 'Submit support request';
    return {
      link: _objectSpread({
        href: supportTicketSystemUrl,
        'aria-label': "".concat(label),
        children: label
      }, commonAttributes),
      analytics: {
        /* TODO: MC-5884 confirm the link type */
        linkType: SupportResourcesLink.ISSUE_TRACKER,
        attributes: {
          linkText: label
        }
      }
    };
  }
  if (issueTrackerUrl) {
    const label = 'Submit support request';
    return {
      link: _objectSpread({
        href: issueTrackerUrl,
        'aria-label': "".concat(label),
        children: label
      }, commonAttributes),
      analytics: {
        linkType: SupportResourcesLink.ISSUE_TRACKER,
        attributes: {
          linkText: label
        }
      }
    };
  }
  if (websiteUrl) {
    const label = 'Visit support website';
    return {
      link: _objectSpread({
        href: websiteUrl,
        'aria-label': "".concat(label),
        children: label
      }, commonAttributes),
      analytics: {
        linkType: SupportResourcesLink.SUPPORT_WEBSITE,
        attributes: {
          linkText: label
        }
      }
    };
  }
  return null;
};
export const SupportRequest = props => {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const {
    onSupportLinkClick,
    supportDetails
  } = props;
  const request = getSupportRequestDetails(supportDetails);
  if (!request) return null;
  const {
    link,
    analytics
  } = request;
  const onLinkClick = () => {
    onSupportLinkClick(analytics.linkType);
    fireAnalyticsEvent({
      eventType: LinkClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_SUPPORT_TICKET_LINK,
      eventContainer: EVENT_CONTAINER_SUPPORT_APPLISTING_TAB,
      attribes: analytics.attributes
    });
  };
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx(LinkButton, _objectSpread(_objectSpread({}, link), {}, {
      onClick: onLinkClick
    }))
  });
};